import styled from '@emotion/styled';
import { COLORS_BACKGROUND } from '../../styles/emotion/colors';

const controlHeight = '38px';

const fadeBottomStyle = (backgroundFadeColor: string = COLORS_BACKGROUND.WHITE) => `
&:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${controlHeight};
  height: 100px;
  background-color: transparent;
  pointer-events: none;
  background-image: linear-gradient(rgba(252, 252, 252, 0), ${backgroundFadeColor} 90%);
}
`;

export const DrawerContainer = styled.div<{
  fadeBottom: boolean;
}>`
  ${({ fadeBottom }) => (fadeBottom ? 'position: relative;' : '')};
`;

export const DrawerContent = styled.div<{
  fadeBottom: boolean;
  backgroundFadeColor: string | undefined;
}>`
  overflow: hidden;
  transition: max-height 0.2s ease;
  ${({ fadeBottom, backgroundFadeColor }) =>
    fadeBottom ? fadeBottomStyle(backgroundFadeColor) : ''};
`;

export const DrawerExpandButtonContainer = styled.div`
  text-align: center;
  height: ${controlHeight};
`;
